<template>
    <div class="action-container">
        <div>
            <el-row type="flex" justify="center" v-loading.fullscreen.lock="loading" element-loading-text="小微帮您拼命加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <el-col :span="24">
                    {{app ? app.app_name : ''}}.检查系统
                </el-col>
            </el-row>
        </div>
        <div>
            <el-row type="flex" justify="center" style="margin:20px 0">
                <el-col :span="24">
                    <el-input v-model="duixiang_name_kw" @blur="searchByname(duixiang_name_kw)" @keyup.enter.native="searchByname(duixiang_name_kw)" @input="searchByname(duixiang_name_kw)" size="mini" placeholder="对象名关键字查找" />
                </el-col>
            </el-row>
            <el-row>
                <Tag v-for="(tag, index) in jcdx_tags" checkable :checked="tag['is_checked'] ? true : false" @click.native="searchByTag(tag, index)" class="tag" color="#008080" :key="index">{{tag.tag_name}}</Tag>
            </el-row>
            <el-row type="flex" justify="start">
                <Tag color="teal" @click.native="showAll"><i class="el-icon-view"></i>显示全部</Tag>
                <Tag color="#67c23a" @click.native="batchAction"><i class="el-icon-edit"></i>批量操作</Tag>
                <Tag color="#03A9F4" @click.native="allSelect"><i class="el-icon-check"></i>反向选择</Tag>
            </el-row>
            <el-row v-for="(jcdx, jcdx_index) in cur_jcdxs">
                <div class="lb">
                    <el-row>
                        <el-col>
                            <el-row>
                                <el-col :span="2" :class="{'lib-checked': jcdx.checked}">
                                    <div class="wc-icon-check" @click="batchCheck(jcdx, jcdx_index)"><i v-show="jcdx.checked" class="el-icon-check"></i></div>
                                </el-col>
                                <el-col :span="4">
                                    <el-row v-on:click="$emit('clickList')" :class="{'lib-checked': jcdx.checked}">
                                        {{ jcdx.duixiang_name }}
                                    </el-row>
                                </el-col>
                                <el-col :span="6" :offset="12">
                                    <el-row type="flex" justify="end">
                                        <i class="el-icon-arrow-right" @click="toAction(jcdx)"></i>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </el-row>
        </div>
        <el-dialog title="批量操作" :visible.sync="dialogFormVisible" :fullscreen="true">
            <el-row v-for="(item, item_index) in items" :label="item.item_name">
                <wc-radio :label="item.item_name" @setReqdata="setReqDatas" :options="item.options"></wc-radio>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="batchSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import axios from 'axios'
import config from '../config.js'
import { Tag } from 'iview'
//import List from './cell/List.vue'
import WcRadio from './cell/WcRadio.vue'
export default {

    components: {
        Tag,
        // List,
        WcRadio
    },
    data() {
        return {
            app_id: '',
            app: null,
            items: [],
            jcdx_tags: [],
            jcdxs: [],
            cur_jcdxs: [],
            loading: true,
            tags_ids: [],
            duixiang_name_kw: '',
            data: [],
            all_select: [],
            cur_jcdx: null,
            ischecked: false,
            showSelect: false,
            dialogFormVisible: false
        }
    },
    metaInfo: {
        meta: [
            { charset: 'utf-8',name: 'viewport' ,content:'width=device-width, initial-scale=1'},
        ]
    },
    created() {
        this.checkLogin()
        this.app_id = this.$route.params.app_id
        this.getApp()

    },
    methods: {
        getApp() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                // localStorage.setItem(response.data.app_id, JSON.stringify(response.data))
                this.app = res
                this.getDuixiang()
                this.getTags()

            }).catch((err) => {
                //console.log(err);
            })
        },
        setAllSelect() {
            for (let i = 0; i < this.items.length; i++) {
                let arr = []
                for (let j = 0; j < this.items[i].options.length; j++) {
                    arr.push({
                        select: false,
                        text: this.items[i].options[j].option_name,
                        option_id: this.items[i].options[j].option_id,
                        item_id: this.items[i].item_id,
                        item_name: this.items[i].item_name
                    })
                }
                this.all_select.push(arr)

            }
        },
        setReqData() {
            //组装请求数据
            let jcdxs = this.cur_jcdxs
            let items = this.items
            this.data = []
            for (let i = 0; i < jcdxs.length; i++) {
                let arr = []
                if (jcdxs[i].checked) {
                    for (let j = 0; j < items.length; j++) {
                        arr.push({
                            item_id: items[j].item_id,
                            option_id: items[j].options[0].option_id,
                            jcdx_id: jcdxs[i].duixiang_id,
                            jcdx_name: jcdxs[i].duixiang_name
                        })
                    }
                    this.data.push(arr)
                }

            }

        },
        setReqDatas(option) {
            let data = this.data
            let items = this.items
            for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < items.length; j++) {
                    for (let k = 0; k < items[j].options.length; k++) {
                        if (items[j].options[k].option_id == option.option_id) {
                            data[i][j].option_id = option.option_id
                            this.data.splice(i, 1, data[i])
                        }
                    }
                }
                //this.jcdxs[i].option_id
            }
        },
        onSwitchChange(select, index) {
            //console.log(select, index)
            let all_select = this.all_select
            for (let i = 0; i < all_select.length; i++) {
                for (let j = 0; j < all_select[i].length; j++) {
                    if (select.item_id == all_select[i][j].item_id) {
                        if (all_select[i][j].option_id == select.option_id) {
                            if (!this.all_select[i][j].select) {
                                this.all_select[i][j].select = false
                            } else {
                                this.all_select[i][j].select = true
                            }
                        } else {
                            this.all_select[i][j].select = false
                        }
                    }

                }
            }

            let data = this.data
            for (let i = 0; i < data.length; i++) {
                if (data[i].item_id == select.item_id) {
                    this.data[i].option_id = select.option_id
                }
            }
        },
        getItem() {
            let url = config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/items'
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.items = res
                this.setReqData()
                this.setAllSelect()
            }).catch((err) => {
                //console.log(err);
            })
        },
        getDuixiang() {
            let url = config.base_url + '/yun_table/yun_duixiang?group_id=' + this.app.jcdx_group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                //console.log(response)
                let res = response.data
                this.jcdxs = res
                for (let i = 0; i < this.jcdxs.length; i++) {
                    this.jcdxs[i].checked = false
                }
                this.cur_jcdxs = this.jcdxs
                this.loading = false
                this.getItem()
            })
        },

        getTags() {
            let url = config.base_url + '/yun_table/yun_duixiang_tags?group_id=' + this.app.jcdx_group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.jcdx_tags = res
            })
        },
        showAll() {
            this.cur_jcdxs = this.jcdxs
            this.setReqData()
            this.tags_ids = []
            for (let i = 0; i < this.jcdx_tags.length; i++) {
                this.jcdx_tags[i].is_checked = false
            }
        },
        searchByTag(tag, index) {
            //console.log(tag,index)
            //this.cur_jcdxs = []
            let tags_ids = this.tags_ids
            let jcdxs = this.jcdxs

            function hasTag() {
                if (tags_ids.length > 0) {
                    for (let i = 0; i < tags_ids.length; i++) {
                        if (tags_ids[i] == tag.tag_id) {
                            return true
                        }
                    }
                }
                return false
            }
            if (hasTag()) {
                //console.log(index)
                this.tags_ids.splice(this.arrIndex(tag.tag_id, tags_ids), 1)
                this.jcdx_tags[index].is_checked = false
                if (this.tags_ids.length < 1) {
                    this.showAll()
                    return false
                }

            } else {
                this.tags_ids.push(tag.tag_id)
                this.jcdx_tags[index].is_checked = true
            }
            this.cur_jcdxs = []
            for (let i = 0; i < jcdxs.length; i++) {
                if (jcdxs[i].tags.length < 1) {
                    continue;
                }
                let dx_tag_id = []
                for (let j = 0; j < jcdxs[i].tags.length; j++) {
                    dx_tag_id.push(jcdxs[i].tags[j].tag_id)
                    // if(this.inArray(duixiangs[i].tags[j].tag_id, tags_ids)){
                    //  this.showing_duixiangs.push(duixiangs[i])
                    // }
                }
                if (this.arrInArray(this.tags_ids, dx_tag_id)) {
                    this.cur_jcdxs.push(jcdxs[i])
                }

            }
            this.setReqData()
        },
        searchByname(kw) {
            //console.log(kw)
            if (!kw) {
                this.showAll()
                return false
            }
            let jcdxs = this.jcdxs
            if (kw) {
                //this.cur_page_jcdxs = []
                this.cur_jcdxs = []
                let patten = new RegExp(kw)
                for (let i = 0; i < jcdxs.length; i++) {
                    if (patten.test(jcdxs[i].duixiang_name)) {
                        this.cur_jcdxs.push(jcdxs[i])
                    }
                }
            }
            this.duixiang_name_kw = ''
            this.setReqData()

        },
        inArray(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return true
                }
            }
        },
        arrIndex(item, arr) {
            for (let i = 0; i < arr.length; i++) {
                if (item == arr[i]) {
                    return i
                }
            }
            return -1
        },
        arrInArray(arr1, arr2) {
            if (arr1.length < 1) {
                return false
            }
            for (let i = 0; i < arr1.length; i++) {
                if (!this.inArray(arr1[i], arr2)) {
                    return false
                }
            }
            return true
        },
        toAction(jcdx) {
            this.cur_jcdx = null
            this.cur_jcdx = jcdx
            this.$router.push({
                name: 'action',
                app_id: this.app.app_id,

                query: {
                    jcdx_id: jcdx.duixiang_id,
                    jcdx_name: jcdx.duixiang_name,
                }
            })
        },
        batchCheck(jcdx, jcdx_index) {

            jcdx.checked = !jcdx.checked
            this.cur_jcdxs.splice(jcdx_index, 1, jcdx)

        },
        batchAction() {
            let cur_jcdxs = this.cur_jcdxs
            this.setReqData()
            if (this.data.length < 1) {
                this.$message.error('至少选择一个操作');
                return false
            }
            this.dialogFormVisible = true


        },
        batchSubmit() {
            this.dialogFormVisible = false
            let _this = this

            axios({
                    method: 'post',
                    headers: {
                        "Authorization": localStorage.getItem('token')
                    },
                    url: config.base_url + '/yun_table/yun_jiancha/apps/' + this.app_id + '/res/batch_save',
                    data: this.data
                })
                .then(function(response) {
                    //console.log(response)

                    _this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    // _this.$router.go(-1)
                })
                .catch((err) => {
                    //console.log(err.response)
                    let err_data = err.response.data.err_msg
                    this.$message({
                        message: err_data,
                        type: 'error'
                    })
                })

        },
        checkLogin() {
            let url = config.base_url + '/yun_table/users/islogin';
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data;
                if (res.login) {
                    console.log('login true');
                } else {
                    console.log('login false');
                    this.$router.push({
                        'path': '/login'
                    })
                }
            })

        },
        allSelect() {

            let cur_jcdxs = this.cur_jcdxs
            for (let i = 0; i < cur_jcdxs.length; i++) {
                let jcdx = cur_jcdxs[i]
                jcdx.checked = !jcdx.checked
                this.cur_jcdxs.splice(i, 1, jcdx)
            }
        }
    }

}
</script>
<style>
.action-container {
    font-size: 14px;
}

.lb {
    border-bottom: 1px solid #ebeef5;
    ;
    padding: 15px 0;
    color: #303133;
    cursor: pointer;
}

.wc-icon-check {
    display: block;
    width: 18px;
    height: 18px;
    line-height: 16px;
    border: 0.5px solid #717070;
}

.lib-checked {

    color: teal;
}
</style>